if (!customElements.get('bz-product-model')) {
  customElements.define(
    'bz-product-model',
    class ProductModel extends HTMLElement {
      constructor() {
        super();
        this.querySelector('[id^="3d-model-"]')
          ?.addEventListener('click', () => this.load());
      }
      load() {
        if (this.hasAttribute('loaded')) return;
        this.setAttribute('loaded', '');

        const tpl = this.querySelector('template');
        if (!tpl) return;

        const viewer = tpl.content.querySelector('model-viewer').cloneNode(true);
        this.append(viewer);

        viewer.style.display = 'block';
        setTimeout(() => (viewer.style.display = ''), 0);

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: e =>
              !e && new Shopify.ModelViewerUI(this.querySelector('model-viewer')),
          },
        ]);
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductmodelJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};
window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});